<shared-ui-cards-card>
  <strong> {{ text }} </strong>&nbsp;©&nbsp; {{ year }}
</shared-ui-cards-card>
